export default {
    list: {
        method: 'get',
        url: '/operators'
    },
    detail: {
        method: 'get',
        url: '/operators/:id'
    },
    add: {
        method: 'post',
        url: '/operators'
    },
    edit: {
        method: 'patch',
        url: '/operators/:id'
    },
    delete: {
        method: 'delete',
        url: '/operators/:id'
    }
};



// WEBPACK FOOTER //
// ./src/api/account.js